import { useVirtualizer } from '@tanstack/react-virtual';
import type { ReactElement, RefObject } from 'react';
import type { ChartDataRow } from '../../../types';
import { StyledTableBody } from '../styled';
import TableBodyRow from './TableBodyRow';
import type { TableBodyBaseProps } from '../types';
interface TableVirtualBodyProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> extends TableBodyBaseProps<DataKey, DataRow> {
  tableContainerRef: RefObject<HTMLDivElement | null>;
}
const TableBody = <DataKey extends string, DataRow extends ChartDataRow<DataKey>>({
  table,
  tableContainerRef,
  isFetchLoading,
  ...commonProps
}: TableVirtualBodyProps<DataKey, DataRow>): ReactElement => {
  const {
    rows
  } = table.getRowModel();
  const rowVirtualizer = useVirtualizer<HTMLDivElement, HTMLTableRowElement>({
    count: rows.length,
    estimateSize: () => 33,
    //estimate row height for accurate scrollbar dragging
    getScrollElement: () => tableContainerRef.current,
    // measure dynamic row height, except in firefox because it measures table border height incorrectly
    measureElement: globalThis.window !== undefined && !navigator.userAgent.includes('Firefox') ? element => element?.getBoundingClientRect().height : undefined,
    overscan: 5
  });
  const virtualRows = rowVirtualizer.getVirtualItems();
  const height = rowVirtualizer.getTotalSize();
  return <StyledTableBody height={height} isInteractionDisabled={isFetchLoading === true}>
      {virtualRows.map(virtualRow => {
      const row = rows[virtualRow.index];
      return <TableBodyRow<DataKey, DataRow> key={row.id} row={row} virtualRow={virtualRow} rowVirtualizer={rowVirtualizer} isFetchLoading={isFetchLoading} {...commonProps} />;
    })}
    </StyledTableBody>;
};
export default TableBody;